import Resource from '@/api/resources/Resource'

class CommonCaseServices extends Resource {
    async getAssociatedCases(labId, caseId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${caseId}/associatedCases`)
        return response.data
    }

    async getPreviousCases(loggedLaboratory, patId) {
        const params = {
            loggedLaboratory
        }
        const response = await this.axios.get(`/common/patients/${patId}/previousCases`, { params })
        return response.data
    }
    async getPreviousCasesLinked(loggedLaboratoryId, patId) {
        const params = {
            loggedLaboratoryId
        }
        const response = await this.axios.get(`/common/patients/${patId}/previousCasesLinked`, { params })
        return response.data
    }

    async getCasesByOwnerLaboratory(loggedLaboratory, patientId) {
        const params = {
            loggedLaboratory
        }
        const response = await this.axios.get(`/common/patients/${patientId}/casesByOwnerLaboratory`, { params })
        return response.data
    }

    async findByLabel(laboratoryId, caseLabel) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseLabel}/findByLabel`)
        return response.data
    }

    async getTracking(laboratoryId, caseId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/tracking`)
        return response.data
    }

    async search(params) {
        const response = await this.axios.get('/common/cases/search', { params })
        return response.data
    }

    async hierarchicalCaseIndexTree(labId, casId, withAttachments) {
        const params = {
            withAttachments: withAttachments
        }
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${casId}/hierarchicalCaseIndexTree`, { params })
        return response.data
    }

    async patientPreviousCasesCountByLaboratory(labId, patId) {
        const params = {
            loggedLaboratory: labId
        }
        const response = await this.axios.get(`/common/patients/${patId}/previousCases/count`, { params })
        return response.data
    }
    async getCaseAPReport(laboratoryId, casId, casesAssociated, print) {
        return this.axios.get(`/common/laboratories/${laboratoryId}/cases/${casId}/reports`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    casesAssociated: casesAssociated,
                    encoded: print
                },
                responseType: print ? null : 'arraybuffer'
            }).then(response => response.data)
    }
}

export default new CommonCaseServices()
